import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={props?.width || 14} height={props?.height || 14} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g stroke={props?.stroke || '#070F21'}>
      <path
        className="path1"
        d="M.96 10.268a3.132 3.132 0 0 0 2.753 2.76c1.07.12 2.167.222 3.287.222s2.218-.102 3.287-.222a3.132 3.132 0 0 0 2.753-2.76c.114-1.063.21-2.155.21-3.268s-.096-2.205-.21-3.269a3.132 3.132 0 0 0-2.753-2.76C9.217.853 8.12.75 7 .75S4.782.852 3.713.972A3.132 3.132 0 0 0 .96 3.732C.846 4.794.75 5.886.75 7s.096 2.205.21 3.268Z"
        fill="#fff"
      />
      <path className="path2" d="M4 4.5h3M10 9.5H7" strokeLinecap="round" strokeLinejoin="round" />
      <path
        className="path2"
        d="M8.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="path2"
        d="M5.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const ModuleFiltersIcon = memo(ForwardRef);
export default ModuleFiltersIcon;
